import { useContext } from "react";
import { FlightDataListContext } from "../contexts/FlightDataListContext";

function useFlightDataList() {
    return useContext(FlightDataListContext);
}

export default useFlightDataList